'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('services.selfAccessRequest',[])
.factory('selfAccessRequestService', ['$http', '$q', function ($http, $q) {

    var baseUrl = environment.apiUrl + '/ID/API/SelfAccessRequest';
    var service = {};

    service.getSelfAccessRequest = function (userAccessRequestId) {
        var reqUrl = baseUrl + '/' + userAccessRequestId
        return $http.get(reqUrl)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getSelfAccessRequestWithSNOWParams = function (userAccessRequestId) {
        var reqUrl = baseUrl + '/' + userAccessRequestId + '/WithSNOWParams'

        return $http.get(reqUrl)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.cancelSelfAccessRequestOwnership = function (userAccessRequestId) {
        var reqUrl = baseUrl + '/' + userAccessRequestId + '/Owner/Cancel'
        return $http.post(reqUrl)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getAdHocSelfAccessRequestStatus = function (username) {
        var reqUrl = baseUrl + '/AdHoc/For/Employee@' + username + '/Status';

        return $http
                .get(reqUrl)
                .then(function (response) {
                    return response.data;
                });
    }

    service.createAdHocSelfAccessRequest = function (employeeId) {

        var reqUrl = baseUrl + '/AdHoc/For/Employee@' + employeeId;
        return $http.post(reqUrl)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.deleteAdHocSelfAccessRequest = function (userAccessRequestId) {

        var reqUrl = baseUrl + '/' + userAccessRequestId + '/AdHoc';
        return $http.delete(reqUrl)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.setSelfAccessRequestToUserAccessRequest = function (userAccessRequestId) {
        var reqUrl = baseUrl + '/' + userAccessRequestId + '/To/UserAccessRequest'
        return $http.post(reqUrl)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getSelfAccessRequestsWithoutOwnerForEmployee = function (employeeId) {
        var reqUrl = baseUrl + '/For/Employee@' + employeeId + '/And/WithoutOwner';
        return $http
                .get(reqUrl)
                .then(function (response) {
                    return response.data;
                });
    }

    service.getSelfAccessRequestsWithoutOwnerForSupervisor = function () {
        var reqUrl = baseUrl + '/For/Supervisor/And/WithoutOwner';
        return $http
                .get(reqUrl)
                .then(function (response) {
                    return response.data;
                });
    }

    service.getSelfAccessRequestsToProcessForEmployee = function (employeeId) {
        var reqUrl = baseUrl + '/For/Employee@' + employeeId + '/ToProcess'
        return $http.get(reqUrl)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.takeOwnershipOfSelfAccessRequest = function (userAccessReqId) {
        var reqUrl = baseUrl + '/' + userAccessReqId + '/Owner';

        return $http.post(reqUrl)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.transferOwnershipOfSelfAccessRequest = function (userAccessReqId,employeeId) {
        var reqUrl = baseUrl + '/' + userAccessReqId + '/Owner/Transfer/'+ employeeId;

        return $http.post(reqUrl)
            .then(function (response) {
                return response.data;
            });
    }

    service.takeoverSelfAccessRequest = function (userAccessReqId) {
        var reqUrl = baseUrl + '/' + userAccessReqId + '/Owner/Takeover';

        return $http.post(reqUrl)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getProcessStepStatusListForSelfAccessRequest = function (userAccessRequestId) {
        var reqUrl = baseUrl + '/' + userAccessRequestId + '/ProcessStep'
        return $http.get(reqUrl)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getUserSystemRoleDecisionsByProcessStep = function (userAccessRequestId, processStep) {
        var reqUrl = baseUrl + '/' + userAccessRequestId + '/ProcessStep/' + processStep;
        return $http.get(reqUrl)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getUserSystemRoleDecisionsToValidate = function (userAccessRequestId) {
        var reqUrl = baseUrl + '/' + userAccessRequestId + '/UserSystemRoleDecision/ToValidate';
        return $http.get(reqUrl)
                    .then(function (response) {
                        return response.data;
                    });
    }



    service.searchAvailableSystemsForSelfAccessRequest = function (userAccessRequestId, searchTerm) {
        var reqUrl = baseUrl + '/' + userAccessRequestId + '/System/Search/Available'
        return $http.get(reqUrl, { params: { "searchTerm": searchTerm } })
                    .then(function (response) {
                        return response.data;
                    });
    }



    service.updateUserSystemRoleDecision = function (userAccessReqId, userSystemRoleDecisionId, userSystemRoleDecision) {
        var reqUrl = baseUrl + '/' + userAccessReqId + '/UserSystemRoleDecision/' + userSystemRoleDecisionId;

        return $http.post(reqUrl, userSystemRoleDecision)
                    .then(function (response) {


                        return response.data;
                    });
    }

    service.updateAllUserSystemRoleDecisions = function (userAccessReqId, userSystemRoleDecisionList) {
        var reqUrl = baseUrl + '/' + userAccessReqId + '/UserSystemRoleDecision/Update';

        return $http.post(reqUrl, userSystemRoleDecisionList)
                    .then(function (response) {
                        return response.data;
                    });
    }
    service.confirmUserSystemRoleDecisionList = function (userAccessReqId, userSystemRoleDecisionList) {
        var reqUrl = baseUrl + '/' + userAccessReqId + '/UserSystemRoleDecision/Confirm';
        return $http.post(reqUrl, userSystemRoleDecisionList)
                    .then(function (response) {
                        return response.data;
                    });
    }


    service.skipProcessStepForSelfAccessRequest = function (userAccessReqId, processStep) {
        var reqUrl = baseUrl + '/' + userAccessReqId + '/ProcessStep/' + processStep + '/Skip';
        return $http.post(reqUrl)
                    .then(function (response) {
                        return response.data;
                    });
    }

    // Location Equipment
    service.updateSelfAccessRequestLocationEquipement = function (userAccessReqId, selfAccessRequest) {
        var reqUrl = baseUrl + '/' + userAccessReqId + '/ProcessStep/LocationEquipment';
        return $http.put(reqUrl, selfAccessRequest)
                   .then(function (response) {
                       return response.data;
                   });
    }

    // Remove Rights
    service.createRemoveRightsDecisions = function (userAccessReqId) {
        var reqUrl = baseUrl + '/' + userAccessReqId + '/ProcessStep/RemoveRights';
        return $http.post(reqUrl)
                    .then(function (response) {
                        return response.data;
                    });
    }

    // Pre-Authorize
    service.createPreAuthorizedDecisions = function (userAccessReqId) {
        var reqUrl = baseUrl + '/' + userAccessReqId + '/ProcessStep/PreAuthorized';
        return $http.post(reqUrl)
                    .then(function (response) {
                        return response.data;
                    });
    }

    // Same-As
    service.selectSameAsEmployee = function (userAccessReqId, sameAsEmployeeId) {
        var reqUrl = baseUrl + '/' + userAccessReqId + '/ProcessStep/SameAs/For/Employee@' + sameAsEmployeeId;
        return $http.post(reqUrl)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.confirmProcessStepForSelfAccessRequest = function (userAccessReqId, processStep) {
        var reqUrl = baseUrl + '/' + userAccessReqId + '/ProcessStep/' + processStep + '/Confirm';
        return $http.post(reqUrl)
                    .then(function (response) {
                        return response.data;
                    });
    }

    // Other Catalog

    service.createOtherCatalogDecisions = function (userAccessReqId, systemId) {
        var reqUrl = baseUrl + '/' + userAccessReqId + '/ProcessStep/OtherCatalogPermissions/For/System@' + systemId;
        return $http.post(reqUrl)
                    .then(function (response) {
                        return response.data;
                    });
    }

    // Special Needs

    service.createOrUpdateSpecialNeedsFollowup = function (userAccessReqId, followup) {
        var reqUrl = baseUrl + '/' + userAccessReqId + '/ProcessStep/SpecialNeeds';
        return $http.post(reqUrl, followup)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getSpecialNeedsFollowup = function (userAccessReqId) {
        var reqUrl = baseUrl + '/' + userAccessReqId + '/ProcessStep/SpecialNeeds'

        return $http.get(reqUrl)
                    .then(function (response) {
                        return response.data;
                    });
    }

    // Lookups
    service.getSelfAccessRequestLookups = function () {
        var reqUrl = baseUrl + '/Lookup';

        return $http.get(reqUrl, { cache: true })
                    .then(function (response) {
                        return response.data;
                    });
    }

    return service;
}]);
